export default __webpack_public_path__ + "static/media/Orastes's Robe.0f48e2e3.jpg";